import type {
  ProviderItem,
  ProvidersResponse,
} from '@/entities/provider/model/types';
import { useProviders } from '@/entities/provider/model/use-providers';

const providersIndexCache = new WeakMap<
  ProvidersResponse,
  Map<string, ProviderItem>
>();

const getProvidersIndex = (providers: ProvidersResponse) => {
  const cached = providersIndexCache.get(providers);
  if (cached) return cached;

  const index = new Map<string, ProviderItem>();
  for (const provider of providers) {
    if (!index.has(provider.id)) index.set(provider.id, provider);
  }
  providersIndexCache.set(providers, index);

  return index;
};

export function useProviderById(id?: string | null) {
  const { providers } = useProviders();

  if (!providers || !id) return undefined;

  return getProvidersIndex(providers).get(id);
}
